import { render, staticRenderFns } from "./mobile1.vue?vue&type=template&id=7f5a144b&scoped=true&"
import script from "./mobile1.vue?vue&type=script&lang=js&"
export * from "./mobile1.vue?vue&type=script&lang=js&"
import style0 from "./mobile1.vue?vue&type=style&index=0&id=7f5a144b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a144b",
  null
  
)

export default component.exports